// クーポンのcommodity_codeを判定
export const isCouponsCommodityCode = (commodityCode) => {
  const commodityCodes = [
    "ea139507-f32d-13ad-4fc2-0fb7f6b0b337", // 特急サブスク
    "5f2b884e-c229-40fc-93e1-2ee643594a68", // 特付FP
    "d830951e-e94e-436c-a0b4-d4ef60ebd00c", // EBINA Passport
    "2e480cf1-c293-429e-aa15-a96adb5148e0", // ポイント交換
  ];

  return commodityCodes.includes(commodityCode);
};
